import { render } from "./MenuView.vue?vue&type=template&id=c78eeaae&scoped=true"
import script from "./MenuView.vue?vue&type=script&lang=js"
export * from "./MenuView.vue?vue&type=script&lang=js"

import "./MenuView.vue?vue&type=style&index=0&id=c78eeaae&scoped=true&lang=css"

import exportComponent from "../../../../../../../../2026-11-02/referenced-chatgpt-conversation-this-is-an-4/outputs/docker-delivery-user-management/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c78eeaae"]])

export default __exports__